// @ts-check
/**
 * Typed client for the opportunities API.
 *
 * TYPES ARE GENERATED, NOT HAND-WRITTEN. See `schema.d.ts` header for details.
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */

/** @typedef {Schemas['CheckEnrollmentRequest']} CheckEnrollmentRequest */
/** @typedef {Schemas['CheckEnrollmentResponse']} CheckEnrollmentResponse */
/** @typedef {Schemas['EnrollPatientRequest']} EnrollPatientRequest */
/** @typedef {Schemas['EnrollPatientSuccessResponse']} EnrollPatientSuccessResponse */

/**
 * POST /api/opportunities/check-enrollment/ — fetch a patient's enrolled opportunities.
 *
 * @param {CheckEnrollmentRequest} body
 * @param {import('axios').AxiosRequestConfig} [config]
 * @returns {Promise<CheckEnrollmentResponse>}
 */
export async function checkEnrollment(body, config) {
  const { data } = await axios.post('/api/opportunities/check-enrollment/', body, config)
  return data
}

/**
 * POST /api/opportunities/enroll-patient/ — manually enroll one patient.
 *
 * Callers must provide metric_id and first_task_due_date. Include a resolved
 * entity_id when available. The API normalizes weekend and holiday due dates
 * for the first task.
 *
 * @param {EnrollPatientRequest} body
 * @param {import('axios').AxiosRequestConfig} [config]
 * @returns {Promise<EnrollPatientSuccessResponse>}
 */
export async function enrollPatient(body, config) {
  const { data } = await axios.post('/api/opportunities/enroll-patient/', body, config)
  return data
}
